"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rest_api_1 = require("@nimles/rest-api");

var actionTypes_1 = require("../actionTypes");

exports.loadProductGroups = function (queryParameters) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.getProductGroups(auth, queryParameters)];

          case 1:
            response = _a.sent();
            if (!response.data) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , dispatch({
              type: actionTypes_1.LOAD_PRODUCT_GROUPS,
              data: response.data
            })];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
};

exports.loadProductGroup = function (id) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.getProductGroup(auth, id)];

          case 1:
            response = _a.sent();
            if (!response.data) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , dispatch({
              type: actionTypes_1.LOAD_PRODUCT_GROUP,
              data: response.data
            })];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
};

exports.createProductGroup = function (data) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.postProductGroup(auth, data)];

          case 1:
            response = _a.sent();

            if (response.data) {
              dispatch({
                type: actionTypes_1.CREATE_PRODUCT_GROUP,
                data: response.data
              });
            }

            return [2
            /*return*/
            , response.data];
        }
      });
    });
  };
};

exports.updateProductGroup = function (data) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.putProductGroup(auth, data)];

          case 1:
            response = _a.sent();

            if (response.data) {
              dispatch({
                type: actionTypes_1.UPDATE_PRODUCT_GROUP,
                data: response.data
              });
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };
};

exports.publishProductGroup = function (id) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.putProductGroupAction(auth, id, 'publish')];

          case 1:
            response = _a.sent();

            if (response.error) {
              return [2
              /*return*/
              , response];
            }

            return [4
            /*yield*/
            , rest_api_1.getProductGroup(auth, id)];

          case 2:
            response = _a.sent();

            if (response.data) {
              dispatch({
                type: actionTypes_1.PUBLISH_PRODUCT_GROUP,
                data: response.data
              });
            }

            return [2
            /*return*/
            , response.data];
        }
      });
    });
  };
};

exports.addProductGroupPermission = function (id, permission) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.postProductGroupPermission(auth, id, permission)];

          case 1:
            response = _a.sent();
            dispatch({
              type: actionTypes_1.ADD_PRODUCT_GROUP_PERMISSION,
              id: id,
              data: __assign(__assign({}, permission), {
                id: response.data.fields['permissionId']
              })
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };
};

exports.setProductGroupAccessibility = function (id, accessibility) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.putProductGroupAccessibility(auth, id, accessibility)];

          case 1:
            _a.sent();

            dispatch({
              type: actionTypes_1.SET_PRODUCT_GROUP_ACCESSIBILITY,
              id: id,
              data: accessibility
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };
};

exports.setProductGroupOrganization = function (id, organizationId) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.putProductGroupOrganization(auth, id, organizationId)];

          case 1:
            _a.sent();

            dispatch({
              type: actionTypes_1.SET_PRODUCTGROUP_ORGANIZATION,
              id: id,
              data: organizationId
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };
};

exports.addProductGroupRelation = function (id, relation) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.postProductGroupRelation(auth, id, relation)];

          case 1:
            response = _a.sent();
            dispatch({
              type: actionTypes_1.ADD_PRODUCTGROUP_RELATION,
              id: id,
              data: __assign(__assign({}, relation), {
                id: response.fields['relationId']
              })
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };
};

exports.removeProductGroupRelation = function (id, relationId) {
  return function (dispatch, getState) {
    return __awaiter(void 0, void 0, void 0, function () {
      var auth, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            auth = getState().auth;
            return [4
            /*yield*/
            , rest_api_1.deleteProductGroupRelation(auth, id, relationId)];

          case 1:
            response = _a.sent();
            dispatch({
              type: actionTypes_1.REMOVE_PRODUCTGROUP_RELATION,
              id: id,
              data: relationId
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };
};